import React, { useRef, useState, useEffect } from 'react';
import Webcam from 'react-webcam';
import axios from 'axios';

import {
    Grid,
    Button,
    Backdrop,
    CircularProgress,
    Typography
} from '@mui/material'

const Camera = () => {
  const webcamRef = useRef(null);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [resURL, setResURL] = useState(null);
  const [isBraden, setIsBraden] = useState(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setIsLoading(true);
    setImage(imageSrc);
  };

  const reset = () => {
    setImage(null);
    setResURL(null);
    setIsBraden(null);
  };


  async function uploadImage() {
    try {
      if (image) {
        const formData = new FormData();
        formData.append('image', image);

        // Replace 'YOUR_BACKEND_URL' with the actual Flask backend endpoint URL
        const response = await axios.post(`${process.env.REACT_APP_BACKEND}/detect`, formData, {
          headers: {
            'Content-Type': 'image/jpeg',
          },
        });

        return response.data;
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      return 0;
    }
  };

  useEffect(() => {
    let prevURL = resURL;
    if (image) {
      uploadImage().then(result => {
        if (result) {
          const byteCharacters = atob(result.image);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });

          const newURL = URL.createObjectURL(blob);
          setResURL(newURL);
          setIsBraden(result.isbraden)
          setIsLoading(false);

          if (prevURL)
            URL.revokeObjectURL(prevURL)
        }
      })
    } else {
      setIsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  const [screenSize, setScreenSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    // Update the screenSize state when the window is resized
    function handleResize() {
      setScreenSize({ width: window.innerWidth, height: window.innerHeight });
    }

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // The empty dependency array ensures the effect runs only once after the initial render

  return (
    <div>
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
      onClick={() => {}}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography variant='h6'>Scanning...</Typography>
        </Grid>
        <Grid item xs={12}>
          <CircularProgress color="inherit" />
        </Grid>
      </Grid>
      
    </Backdrop>
    <Grid container>
        <Grid item xs={12}>
            <Typography variant="h5">Are you Braden Lobb?</Typography>
            {isBraden && <Typography variant="h6" style={{color: 'green'}}>You are Braden!</Typography>}
            {(isBraden !== null && !isBraden) && <Typography variant="h6" style={{color: 'red'}}>You are NOT Braden!</Typography>}
        </Grid>
        <Grid item xs={12}>
          {!image &&
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg" 
              videoConstraints={{
                height: screenSize.height * 0.5
              }}
              mirrored={true}
              />
            }
          {(image && !resURL) &&
            <img src={image} alt="Captured" />}
          {(image && resURL) &&
            <img src={resURL} alt="Result" />}
        </Grid>

        {!image &&
          <Grid item xs={12}>
            <Button onClick={capture}>Capture Photo</Button>
          </Grid>}

        {image && <Grid item xs={12}><Button onClick={reset}>Reset</Button></Grid>}
      </Grid>
      </div>
  );
};

export default Camera;
